import React from "react";
import { isMobile } from "~/utils/helpers";
import Blog from "./blog";
import { Desktop } from "./desktop";
import { Mobile } from "./mobile";

export function UnauthenticatedHome({ animate }) {
  return <Blog />;
}
